export default "__VITE_ASSET__jbZlbsNX__"